import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useUpdateOfferDraftMutation } from "../../../services/draftsService";
import { DocxDraftForm } from "./DocxDraftForm";

export function DocxDraftEditDialog(props) {
    const { t } = useTranslation();
    const { mutate: updateDraft } = useUpdateOfferDraftMutation({
        onSuccess: () => {
            toast.success(t("drafts.saveTemplate"));
            props.onClose();
            props.onSuccessUpdate();
        },
    });

    const handleSubmit = (data) => {
        if (!props.draft) {
            return;
        }
        console.log("Updating offer template with data:", data);
        updateDraft({
            draftId: props.draft.id.toString(),
            data: {
                nr: data.templateNumber,
                name: data.templateName,
                description: data.templateDescription,
                language: data.templateLanguage,
                active: data.active === "true",
            },
        });
    };

    const handleError = (errors) => {
        console.error("Form validation errors:", errors);
    };

    if (!props.draft) {
        return null;
    }

    const defaultValues = {
        templateNumber: props.draft.template_number,
        templateLanguage: props.draft.language,
        templateName: props.draft.template_name,
        templateDescription: props.draft.description,
        active: props.draft.active.toString(),
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                {props.title}
                <IconButton onClick={props.onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <DocxDraftForm
                    defaultValues={defaultValues}
                    onSubmit={handleSubmit}
                    onError={handleError}
                    submitBtnText={t("drafts.saveTemplate")}
                    showFileUpload={false}
                    showActiveField={true}
                />
            </DialogContent>
        </Dialog>
    );
}
